const { createContext, useContext, useState } = require("react");

const ProductContext = createContext();

export const ProductProvider = ({ children }) => {
  const [currentStep, setCurrentStep] = useState(1); // Step management
  // Product Image Upload
  const [uploadedImages, setUploadedImages] = useState([]);
  const [currentCategoryStep, setCurrentCategoryStep] = useState(1); // Category step management

  // State for managing toggle checkbox and the count
  const [isToggleChecked, setIsToggleChecked] = useState(false);

  const [content, setContent] = useState(""); // State to hold the editor content
  // Category Product Upload
  const [uploadCategoryImages, setUploadedCategoryImages] = useState([]);

  // Category Product Attribute  Upload
  const [uploadedImagesAttribute, setUploadedAttributeImages] = useState([]);
  const [productForm, setProductForm] = useState({
    product_name: "",
    product_sku: "",
    product_Category: "",
    product_qty: "",
    images: [],
    socials: {
      shopify: "",
      facebook: "",
      twitter: "",
      instagram: "",
      optional_acc: "",
    },
    product_price: "",
    is_featured: false,
    product_status: "",
    product_type: "",
    product_attributes: [],
    is_customer_req_needed: false,
    addition_req_count: "",
    addition_req_customer: [],
  });

  const [categoryForm, setCategoryForm] = useState({
    category_name: "",
    category_description: "",
    images: [],
    is_parent: "false",
    parent_category_id: "",
  });

  const [attributeForm, setAttributeForm] = useState({
    name: "",
    value: "",
    images: [],
  });

  const [productTypeForm, setProductTypeForm] = useState({
    name: "",
  });

  const [formError, setFormError] = useState({
    product: {},
    category: {},
    attribute: {},
    productType: {},
  });

  const [categoryData, setCategoryData] = useState([]);
  const [parentCategoryData, setParentCategoryData] = useState([]);
  const [productBinaryImage, setProductBinaryImage] = useState([]);
  const [imagesBinary, setBinaryImages] = useState([]);
  const [imagesBinaryAttribute, setBinaryImagesAttribute] = useState([]);
  const [attributeData, setAttributeData] = useState([]);
  const [productTypeData, setProductTypeData] = useState([]);
  const [totalCateogryData, setTotalCategoryData] = useState([]);
  const [selectedProductAttributes, setSelectedProductAttributes] = useState(
    []
  );

  const [count, setCount] = useState(0);
  const rows = new Array(count).fill(null);
  const [productData, setProductData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  return (
    <ProductContext.Provider
      value={{
        productBinaryImage,
        setProductBinaryImage,
        selectedProductAttributes,
        setSelectedProductAttributes,
        totalCateogryData,
        setTotalCategoryData,
        productTypeData,
        setProductTypeData,
        categoryData,
        setCategoryData,
        parentCategoryData,
        setParentCategoryData,
        count,
        rows,
        isToggleChecked,
        setIsToggleChecked,
        setCount,
        content,
        setContent,
        currentStep,
        setCurrentStep,
        currentCategoryStep,
        setCurrentCategoryStep,
        uploadedImages,
        setUploadedImages,
        uploadCategoryImages,
        setUploadedCategoryImages,
        uploadedImagesAttribute,
        setUploadedAttributeImages,
        productForm,
        setProductForm,
        categoryForm,
        setCategoryForm,
        attributeForm,
        setAttributeForm,
        productTypeForm,
        setProductTypeForm,
        formError,
        setFormError,
        imagesBinary,
        setBinaryImages,
        imagesBinaryAttribute,
        setBinaryImagesAttribute,
        attributeData,
        setAttributeData,
        productData,
        setProductData,
        currentPage,
        setCurrentPage,
      }}
    >
      {children}
    </ProductContext.Provider>
  );
};

export const useProductContext = () => {
  return useContext(ProductContext);
};
